import React from "react";
import { ScrollView, Text, TouchableOpacity, View } from "react-native";
import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "../utils/convex-api";
import { useRouter } from "expo-router";
import { Avatar } from "../ui/avatar";
import { useSheet } from "../shared/sheet-provider";
import { SheetIds } from "../utils/sheet-ids";
import type {
  ChildrenSelectSheetPayload,
  ChildrenSelectSheetResult,
} from "../sheets/children-select-sheet";

function ParentTutors() {
  const { data: tutorsData } = useQuery(
    convexQuery(api.parent.home.queries.tutors, {})
  );
  const tutors = tutorsData ?? [];

  const { data: childrenData } = useQuery(
    convexQuery(api.parent.home.queries.children, {})
  );
  const children = childrenData ?? [];

  const router = useRouter();

  const { open } = useSheet<
    ChildrenSelectSheetPayload,
    ChildrenSelectSheetResult
  >(SheetIds.CHILDREN_SELECT);

  if (tutors.length === 0) return null;

  const handleViewProfile = async (tutorId: string) => {
    const [firstChild] = children;
    if (children.length > 1) {
      const result = await open({
        title: "View tutor profile for",
        options: children.map((child) => ({
          label: child.name,
          value: child._id,
          imageUrl: child.imageUrl ?? null,
        })),
        preSelectedOption: firstChild._id,
      });
      if (result.selectedOption) {
        router.push(
          `/(app)/home/find-tutor/${tutorId}?childId=${result.selectedOption}`
        );
      }
    } else if (firstChild) {
      router.push(`/(app)/home/find-tutor/${tutorId}?childId=${firstChild._id}`);
    }
  };

  return (
    <View className="mt-4">
      <Text className="font-geologica-medium font-medium text-[20px] text-gray-800 leading-[1.5]">
        Your tutors
      </Text>

      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerClassName="gap-4 py-4 px-5"
        style={{ marginHorizontal: -20 }}
      >
        {tutors.map((tutor) => (
          <View
            key={tutor!._id}
            className="h-[187] py-[24px] px-[23px] rounded-[12px] bg-white shadow-sm justify-center items-center gap-3"
          >
            <Avatar size="md">
              <Avatar.Content
                size="md"
                label={tutor!.name}
                labelSize="md"
                source={tutor!.imageUrl ? { uri: tutor!.imageUrl } : undefined}
              />
            </Avatar>
            <Text
              className="text-base leading-[24px] font-geologica-regular font-normal text-gray-800"
              numberOfLines={1}
            >
              {tutor!.name}
            </Text>

            <TouchableOpacity onPress={() => handleViewProfile(tutor!._id)}>
              <Text className="text-[14px] leading-[24px] font-geologica-medium font-medium text-teal-600">
                View Profile
              </Text>
            </TouchableOpacity>
          </View>
        ))}
      </ScrollView>
    </View>
  );
}

export default ParentTutors;
